(() => {
  'use strict';

  const BODY_LOCK_CLASS = 'customer-care-lock';
  const CLOSE_DELAY = 1550;

  function initializeCustomerCare() {
    const drawers = document.querySelectorAll(
      '[data-customer-care-drawer]:not([data-customer-care-initialized])'
    );

    drawers.forEach((drawer) => {
      drawer.dataset.customerCareInitialized = 'true';

      const drawerId = drawer.id;
      const panel = drawer.querySelector(
        '.customer-care-drawer__panel'
      );

      const openButtons = document.querySelectorAll(
        `[data-customer-care-open="${CSS.escape(drawerId)}"]`
      );

      const closeButtons = drawer.querySelectorAll(
        '[data-customer-care-close]'
      );
      const chatButton = drawer.querySelector(
  '[data-customer-care-chat]'
);

      let previouslyFocusedElement = null;
      let closeTimer = null;

      /*
       * Keep the drawer directly inside the body so Shopify section
       * containers cannot clip or reposition it.
       */
      if (drawer.parentElement !== document.body) {
        document.body.appendChild(drawer);
      }

      function openDrawer(trigger) {
        window.clearTimeout(closeTimer);

        previouslyFocusedElement =
          trigger instanceof HTMLElement
            ? trigger
            : document.activeElement;

        drawer.hidden = false;
        document.body.classList.add(BODY_LOCK_CLASS);

        openButtons.forEach((button) => {
          button.setAttribute('aria-expanded', 'true');
        });

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            drawer.classList.add('is-open');
          });
        });

        window.setTimeout(() => {
          panel?.focus();
        }, 100);
      }

      function closeDrawer() {
        window.clearTimeout(closeTimer);

        drawer.classList.remove('is-open');
        document.body.classList.remove(BODY_LOCK_CLASS);

        openButtons.forEach((button) => {
          button.setAttribute('aria-expanded', 'false');
        });

        closeTimer = window.setTimeout(() => {
          drawer.hidden = true;

          if (
            previouslyFocusedElement instanceof HTMLElement
          ) {
            previouslyFocusedElement.focus();
          }
        }, CLOSE_DELAY);
      }

      openButtons.forEach((button) => {
        button.addEventListener('click', () => {
          openDrawer(button);
        });
      });

      closeButtons.forEach((button) => {
        button.addEventListener('click', closeDrawer);
      });
      chatButton?.addEventListener('click', () => {
  closeDrawer();

  window.setTimeout(() => {
    window.tidioChatApi?.show();
    window.tidioChatApi?.open();
  }, 550);
});

      drawer.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeDrawer();
        }
      });
    });
  }

  document.addEventListener(
    'DOMContentLoaded',
    initializeCustomerCare
  );

  document.addEventListener(
    'shopify:section:load',
    initializeCustomerCare
  );

  if (document.readyState !== 'loading') {
    initializeCustomerCare();
  }
})();